// extracted by mini-css-extract-plugin
module.exports = {"paymentDialog":"paymentDialog--koqxa","codes":"codes--1hFEw","payway":"payway--NSuJq"};